import APIAxios from '../APIAxios.ts';
import ICurrentIndex from '../view_modals/ICurrentIndex.ts';

interface IGetScoreCardVM {
  sessionId: number | undefined;
  teamId: number | undefined;
}

interface IBonusRequestVM {
  sessionId: number | undefined;
  teamId: number | undefined;
}

interface ISetCollectibleCount {
  teamId: number | undefined;
  userId: number | undefined;
  sessionId: number | undefined;
  collectibleTypeEnumId: number | undefined;
  quantity: number | undefined;
}

const getScoreCard = async (vm: IGetScoreCardVM): Promise<any> => {
  try {
    const { data } = await APIAxios.post('/Scoring/GetScoreCard', vm);
    return data;
  } catch (err) {
    throw err;
  }
};

const setCollectibleCount = async (vm: ISetCollectibleCount): Promise<any> => {
  try {
    const { data } = await APIAxios.post('/Scoring/SetCollectibleCount', vm);
    return data;
  } catch (err) {
    throw err;
  }
};

const fetchBonuses = async (vm: IBonusRequestVM): Promise<any> => {
  try {
    const { data } = await APIAxios.post('/Scoring/GetBonus', vm);
    return data;
  } catch (err) {
    throw err;
  }
};

const saveBonuses = async (vm: IBonusRequestVM): Promise<any> => {
  try {
    const { data } = await APIAxios.post('/Scoring/SaveBonus', vm);
    return data;
  } catch (err) {
    throw err;
  }
};

const fetchFinalTotal = async (vm: IBonusRequestVM): Promise<any> => {
  try {
    const { data } = await APIAxios.post('/Scoring/GetFinalTotal', vm);
    return data;
  } catch (err) {
    throw err;
  }
};

const getCurrentIndex = async (vm: ICurrentIndex): Promise<any> => {
  try {
    const { data } = await APIAxios.get(`/Scoring/GetCurrentIndex/${vm.sessionId}`);
    return data;
  } catch (err) {
    throw err;
  }
};

// Assign the object to a variable before exporting
const apiService = {
  getScoreCard,
  setCollectibleCount,
  fetchBonuses,
  saveBonuses,
  fetchFinalTotal,
  getCurrentIndex,
};

export default apiService;
